import React from 'react';
import PropTypes from 'prop-types';
import { Block, BlockImage } from '../Block';
import Text from '../Typography/Text';
import theme from '../../theme';
import IconSVG from '../Icon/IconSVG';
import styled from 'styled-components';
import ButtonWithLine from '../Button/ButtonWithLine';

const Link = styled.a`
  text-decoration: none;
  cursor: pointer;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

const FacebookEvent = ({ image, title, label, url, date, location }) => {
  return (
    <Block>
      <Link href={url} target="_blank">
        {image && <BlockImage src={image} />}
        <Text
          variant="date"
          color={theme.color.brand.accent}
          marginTop="20px"
          transform="uppercase"
        >
          {date}
        </Text>
        <Text
          variant="heading3"
          color={theme.color.brand.primary}
          as="h3"
          marginTop="5px"
        >
          {title}
        </Text>

        <Text
          variant="description"
          color={theme.color.brand.grey}
          marginTop="10px"
        >
          <IconSVG name="keynote" color={theme.color.brand.accent} mr={10} />
          {location}
        </Text>

        <ButtonWrapper>
          <ButtonWithLine href={url}>{label}</ButtonWithLine>
        </ButtonWrapper>
      </Link>
    </Block>
  );
};

FacebookEvent.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  label: PropTypes.string,
  url: PropTypes.string,
  date: PropTypes.string,
  location: PropTypes.string
};

export default FacebookEvent;
